/** @format */

import { call, put } from 'redux-saga/effects';

import { apiSearch } from '../../api/apiSearch';

export function* sagaSearchList(action: any): Generator<any> {
  try {
    const payload = yield call(apiSearch, action.payload);
    yield put({ type: 'SEARCH_RESULT_LIST_SUCCESS', payload });
  } catch (error) {
    yield put({ type: 'SEARCH_RESULT_LIST_FAILURE' });
  }
}
